
export default () => ({
  activeIndex: 0,
  setActiveIndex(index) {
    this.activeIndex = index;
  }
});
